module.exports = __webpack_public_path__ + "static/media/culture_03.5ce5e5cc.jpg";